import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import Slider from "react-slick";
import ReactPlayer from 'react-player'

class DemoAccordion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            accordions: {
                userStories: {
                    activeIndex: 0,
                    isPaused: true,
                }
            },
            personasSlideshow: {
                arrows: true,
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                focusOnSelect: true,
                rows: 1,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            }
        };
    }

    componentDidMount() {}

    onAccordionClick(accordionId, index) {
        if (!this.state.accordions.hasOwnProperty(accordionId)) {
            return;
        }

        this.setState({
            accordions: {
                ...this.state.accordions,
                [accordionId]: {
                    ...this.state.accordions[accordionId],
                    activeIndex: index,
                }
            }
        });
    }

    onAccordionToggleMedia(accordionId) {
        if (!this.state.accordions.hasOwnProperty(accordionId)) {
            return;
        }

        this.setState({
            accordions: {
                ...this.state.accordions,
                [accordionId]: {
                    ...this.state.accordions[accordionId],
                    isPaused: !this.state.accordions[accordionId].isPaused,
                }
            }
        });
    }

    userStoriesMedia(activeIndex) {
        switch(activeIndex) {
            case 0:
                return (
                    <React.Fragment key="media-userStories-0">
                        <ReactPlayer
                            playing={!this.state.accordions.userStories.isPaused}
                            loop={true}
                            url="/images/meal-planning-plan-a-meal-screen-recording.h264.24.mp4"
                        />
                    </React.Fragment>
                );
            case 1:
                return (
                    <React.Fragment key="media-userStories-1">
                        <ReactPlayer
                            playing={!this.state.accordions.userStories.isPaused}
                            loop={true}
                            url="/images/meal-planning-vote-on-meal-screen-recording.h264.24.mp4"
                        />
                    </React.Fragment>
                );
            case 2:
                return (
                    <React.Fragment key="media-userStories-2">
                        <ReactPlayer
                            playing={!this.state.accordions.userStories.isPaused}
                            loop={true}
                            url="/images/meal-planning-decide-while-shopping-screen-recording.h264.24.mp4"
                        />
                    </React.Fragment>
                );
            case 3:
                return (
                    <React.Fragment key="media-userStories-3">
                        <ReactPlayer
                            playing={!this.state.accordions.userStories.isPaused}
                            loop={true}
                            url="/images/meal-planning-dont-forget-screen-recording.h264.24.mp4"
                        />
                    </React.Fragment>
                );
            default:
                return '';
        }
    }

    render() {
        return (
            <>
                <div className="media-accordion">
                    <Row>
                        <Col xs={12} md={6}>
                            <div className="media">
                                <div className="media-item">
                                    {this.userStoriesMedia(this.state.accordions.userStories.activeIndex)}
                                </div>
                                <button
                                    className="media-toggle"
                                    onClick={() => this.onAccordionToggleMedia('userStories')}
                                >
                                    {!this.state.accordions.userStories.isPaused ? (
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="26.4773" y="23" width="9.27273" height="34" rx="2" fill="#DDAD02"/>
                                            <rect x="44.25" y="23" width="9.27273" height="34" rx="2" fill="#DDAD02"/>
                                        </svg>
                                    ) : (
                                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M57.9546998 38.2408C59.348 38.9969 59.348 41.0031 57.9498 41.7592L29.7251 57.0234C28.3925 57.7441 26.7737 56.7791 26.7737 55.2642L26.7737 24.7358C26.7737 23.2209 28.3925 22.2559 29.7251 22.9766L57.9498 38.2408Z" fill="#DDAD02"/>
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className="accordions">
                                <section className={`accordion-item${this.state.accordions.userStories.activeIndex === 0 ? ' active' : ''}`}>
                                    <header>
                                        <button
                                            onClick={() => this.onAccordionClick('userStories', 0)}
                                        >
                                            <h1>Plan a meal</h1>
                                        </button>
                                    </header>
                                    <div className="content">
                                        <h2>Situation</h2>
                                        <p>As a meal planner, I want to plan for meals ahead of time so that I can reduce stress later in the week</p>
                                        <h2>Findings</h2>
                                        <p>I learned that it was difficult for users to find how to remove a meal, but otherwise they were able to complete this task.</p>
                                    </div>
                                </section>
                                <section className={`accordion-item${this.state.accordions.userStories.activeIndex === 1 ? ' active' : ''}`}>
                                    <header>
                                        <button
                                            onClick={() => this.onAccordionClick('userStories', 1)}
                                        >
                                            <h1>Vote on a meal</h1>
                                        </button>
                                    </header>
                                    <div className="content">
                                        <h2>Situation</h2>
                                        <p>As a meal planner, I want to choose meals to make with others in the household, so that I can share the burden of making decisions</p>
                                        <h2>Findings</h2>
                                        <p>This video is after a second round of updates were made where I simplified the rating to a single up/down arrow both on a recipe single and also on the favorites page.</p>
                                    </div>
                                </section>
                                <section className={`accordion-item${this.state.accordions.userStories.activeIndex === 2 ? ' active' : ''}`}>
                                    <header>
                                        <button
                                            onClick={() => this.onAccordionClick('userStories', 2)}
                                        >
                                            <h1>Decide while shopping</h1>
                                        </button>
                                    </header>
                                    <div className="content">
                                        <h2>Situation</h2>
                                        <p>As a planning assistant, I want to be informed about items on my list so that I can make informed decisions</p>
                                    </div>
                                </section>
                                <section className={`accordion-item${this.state.accordions.userStories.activeIndex === 3 ? ' active' : ''}`}>
                                    <header>
                                        <button
                                            onClick={() => this.onAccordionClick('userStories', 3)}
                                        >
                                            <h1>Don't forget items</h1>
                                        </button>
                                    </header>
                                    <div className="content">
                                        <h2>Situation</h2>
                                        <p>As a planning assistant, I want to organize my list by meals and store so that I don’t forget items while shopping</p>
                                    </div>
                                </section>
                            </div>
                        </Col>
                    </Row>
                </div>
            </>
        )
    }
}

export default DemoAccordion;
